  <template>
  <b-modal style="padding:15px" size="lg" id="EditWheatIssueModal" ref="modal" title="Edit Wheat Issue" ok-title="Submit" cancel-title="Close" 
      @show= "updateModel()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditWheatIssueForm != undefined ? !this.$refs.EditWheatIssueForm.checkValidity() : true">
        <form ref="EditWheatIssueForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group  label="Date Issued" label-for="datepicker-1" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "DateIssued" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="No. Of Sacks" label-for="noOfSacks" autocomplete="off">
                <b-form-input id="noOfSacks" v-model= "NoOfSacks"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Total Weight" label-for="Total Weight" autocomplete="off">
                <b-form-input id="TotalWeight" v-model= "TotalWeight"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddCompany',
    data(){
        return{
          moduleName:'Wheat Issued',
          TotalWeight:'',
          NoOfSacks:'',
          DateIssued:'', 
          Id:null    
		}
  },
  props:{
    wheatIssueToEdit:{
      type:Object,
      default:null
    }
  },

methods:{

    editWheatIssue(){ 
     axios.post('/WheatIssue/edit', 
      {"Id":this.Id,"IssuedDateTime":this.DateIssued,"NoOfSacks":Number(this.NoOfSacks), "IssuedWeight":Number(this.TotalWeight),
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Record has been edited successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
               
                this.$router.go();         
            }
            else 
            {
               this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   checkFormValidity() {
        const valid = this.$refs.EditWheatIssueForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.NoOfSacks = null;
        this.TotalWeight = null;
        this.IssuedDateTime = null;
       
      },
      updateModel()
      {
        this.NoOfSacks = this.wheatIssueToEdit.noOfSacks;
        this.TotalWeight = this.wheatIssueToEdit.issuedWeight;
        this.DateIssued = this.wheatIssueToEdit.issuedDateTime;
        this.Id = this.wheatIssueToEdit.id;
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editWheatIssue()
        
       
      },
 
  
  },
	

}
</script>
